import { unstable_noStore as noStore } from 'next/cache'

import { getTokenClient } from './useGetTokenClient'

export const useApiGet = async (url: string, caching?: boolean) => {
  try {
    const token = await getTokenClient()

    const HEADER = {
      method: 'GET',
      next: { revalidate: caching ? 0 : 10, caches: caching ? 'no-cache' : 'default' },
      headers: {
        'Content-Type': 'application/json',
        // 'Cache-Control': 'no-cache, no-store, must-revalidate',
        Authorization: `Bearer ${token}`,
      },
    }
    noStore()
    const res = await fetch(url, HEADER)
    if (res) return await res.json()

    return
  } catch (err) {
    return err
  }
}
